import { render, staticRenderFns } from "./ServiceDocumentAdd.vue?vue&type=template&id=9dd15986&scoped=true"
import script from "./ServiceDocumentAdd.vue?vue&type=script&lang=js"
export * from "./ServiceDocumentAdd.vue?vue&type=script&lang=js"
import style0 from "./ServiceDocumentAdd.vue?vue&type=style&index=0&id=9dd15986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd15986",
  null
  
)

export default component.exports